import { render, staticRenderFns } from "./live.vue?vue&type=template&id=37851f8d&scoped=true&"
import script from "./live.vue?vue&type=script&lang=js&"
export * from "./live.vue?vue&type=script&lang=js&"
import style0 from "./live.vue?vue&type=style&index=0&id=37851f8d&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37851f8d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/sit-app-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37851f8d')) {
      api.createRecord('37851f8d', component.options)
    } else {
      api.reload('37851f8d', component.options)
    }
    module.hot.accept("./live.vue?vue&type=template&id=37851f8d&scoped=true&", function () {
      api.rerender('37851f8d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/view/live.vue"
export default component.exports